import { render, staticRenderFns } from "./PopupAlert.vue?vue&type=template&id=6219b7f6&scoped=true&"
import script from "./PopupAlert.vue?vue&type=script&lang=js&"
export * from "./PopupAlert.vue?vue&type=script&lang=js&"
import style0 from "./PopupAlert.vue?vue&type=style&index=0&id=6219b7f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6219b7f6",
  null
  
)

export default component.exports